export enum SettingsType {
  Reminders = 'Reminders',
  Music = 'Music',
  Sounds = 'Sounds',
  PerformanceMode = 'PerformanceMode',
}
